import styled from 'styled-components'

export const Bookings = styled.div `
  color: black;
  margin: 15px;
  padding: 15px;
  border: 1px solid rgb(0,0,0,15%);
  background-color: white;
  overflow: hidden;
  @media (max-width: 990px) {
      margin-top: 0px !important;
      margin: 0px;
      padding: 0px;
  }
`

export const Center = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const ResidenceBox = styled.div `
margin-top: 45px;
margin-bottom: 45px; 
padding-top: 20px;
background: white;
border: 1px solid rgb(0,0,0,15%);
@media (max-width: 990px) {
    margin-top: 0px;
}

`

export const ButtonVerticalCenter = styled.div `
`

export const BookingInfo = styled.p `
  height: 25px;
  font-size: 14px;
  color: black;
  opacity: 1;
  margin: 0px;
  padding: 0px;
`

export const Booking = styled.div `
  height: 100%;
`

export const Heading = styled.h2 `
font-size: 20px;
color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
`
export const SubHeading = styled.h2 `
letter-spacing: 0.5;
padding-left: 15px;
font-family: "Catamaran";
font-weight: 300;
font-size: 12px;
color: #DAB777;
`

export const LogeButtonSlim = styled.button `
  border: 1px solid;
  font-weight: 300;
  font-size: 12px;
  background: none;
  color: ${props => props.fontColor} !important;
  z-index: 99 !important;
  visibility: none;
  margin: 5px;
  text-align: center;
  border-radius: 0px !important;
  border-color: ${props => props.color} !important;
  letter-spacing: 1px !important;
  padding: 10px 20px !important; 
  transition: 0.3s;
  text-transform: uppercase;
  &:hover{
    transition: 0.3s;
    background-color: ${props => props.color} !important;
    color: ${props => props.hoverFontColor} !important;

  }
  &:active{
    background-color: ${props => props.color} !important;
    color: ${props => props.hoverFontColor} !important;

  }
`
LogeButtonSlim.defaultProps = {
    color: "#DAB777",
    fontColor: "#DAB777"
}


// WEBPACK FOOTER //
// /src/components/internal/Residence/ActiveResidenceBookingsStyle.js